/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientListModel } from '../../models/client-list-model';

export interface ClientClientListGet$Plain$Params {
}

export function clientClientListGet$Plain(http: HttpClient, rootUrl: string, params?: ClientClientListGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<ClientListModel>>> {
  const rb = new RequestBuilder(rootUrl, clientClientListGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<ClientListModel>>;
    })
  );
}

clientClientListGet$Plain.PATH = '/Client/ClientList';
